import React, { useEffect } from "react";
import { getlocalStorageLogin } from "common/components/apiConfig";
import {
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation,
} from "react-router-dom";
import Login from "./modules/login";
import ProtectedRoute from "./modules/login/protectedRoute/protectedRoute";
import OfflineOrders from "./pages/offlineOrders/index";
import { useDispatch } from "react-redux";
import { actionTypes as auth } from "redux/login";
import { EMPTYALLREDUCERS } from "redux/type";
import Deposit from "./pages/deposit";
import ChangePasswordWithoutAuth from "./pages/changePassword";
import Home from "./pages/home";
import Reports from "./pages/reports";
import Profile from "./pages/profile";
import Invite from "./pages/invite";
import Password from "./pages/password";
import Payments from "./pages/payments";

const BasePage = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const permission = (nationalIdList) => {
    const adminObj = getlocalStorageLogin();

    if (adminObj) {
      const userObject = adminObj?.user;
      const nationalId = userObject?.member_national_id;
      // const nationalId = adminObj?.user?.member_national_id;

      const havepermission = nationalIdList?.filter(
        (item) => `${item}` === nationalId,
      );
      return havepermission.length;
    }
  };

  useEffect(() => {
    const isAsadi = permission(["0016094530"]);

    if (
      (!isAsadi && window.location.pathname === "/basket_management")
    ) {
      history.push("/home");
    }
  }, [history]);

  useEffect(() => {
    const { pathname, search } = window.location;
    if (pathname.startsWith("/auth")) return;

    const adminCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("admin="));

    if (!adminCookie) {
      dispatch({ type: EMPTYALLREDUCERS, payload: {} });
      dispatch({ type: auth.logout, payload: {} });

      // Extract member_national_id param separately
      const params = new URLSearchParams(search);
      const member_national_id = params.get("member_national_id");

      // Remove member_national_id from query string
      params.delete("member_national_id");
      const filteredSearch = params.toString();

      // Build redirectPath
      let redirectPath = "";
      if (pathname.startsWith("/marketer")) {
        redirectPath = pathname + (filteredSearch ? `?${filteredSearch}` : "");
      } else {
        const firstSegment = pathname.split("/")[1];
        redirectPath = `/${firstSegment}${filteredSearch ? `?${filteredSearch}` : ""}`;
      }

      history.push(
        `/auth?page=${encodeURIComponent(redirectPath)}&member_national_id=${encodeURIComponent(member_national_id || "")}`,
      );
    }
  }, [location]);

  return (
    <>
      <Switch>
        <ProtectedRoute path={"/offline-order"} component={OfflineOrders} />
        <ProtectedRoute exact path={"/deposit"} component={Deposit} />
        <ProtectedRoute exact path={"/profile"} component={Profile} />
        <ProtectedRoute exact path={"/reports"} component={Reports} />
        <ProtectedRoute exact path={"/payments"} component={Payments} />

        <Route path="/auth">
          <Login />
        </Route>

        <Redirect from="/" to="/auth" />
      </Switch>
    </>
  );
};

export default BasePage;
//        <ProtectedRoute exact path={"/pledge"} component={PledgeStock} />
//        <ProtectedRoute exact path={"/pledge-spread"} component={Strategy} />
